import { ENTITY_LABELS } from "../../../utils/labelMapping";
import React, { useState, useEffect } from "react";
import {
  prepareTableData,
  transformDataForMultibarChart,
  extractDomain,
  getFilteredPurchaseDimensions,
  generateCompDashboardJsonPrompt,
  customizeFontSizeAndStyle,
  coreAttributesDataTransform,
  getLLMInfo,
} from "../../../utils/helpers";
import ReMultibarChart from "../common/ReMultibarChart";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortUp, faSortDown } from "@fortawesome/free-solid-svg-icons";
import classes from "./DashboardComponent.module.css";
import CustomSelectWithApply from "../common/CustomSelectionComponent";
import { metricExplainations, titleMapping } from "../../../utils/constant";
import CustomTooltip from "../common/CustomTooltip";
import EmptyView from "../../../Component/EmptyView/EmptyView";
import {
  getDashboardSummary,
  getSourcesWithAlias,
} from "../../../services/apiService";
import Markdown from "markdown-to-jsx";
import { Spinner } from "react-bootstrap";
import MUIButton from "./../../../Component/UI/MUIButton/MUIButton";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import { TableCell, TableHead, TableRow, Tooltip } from "@mui/material";
import Modal from "../../../Component/Modal/Modal";
import BrandReachSentimentMeta from "../../../Component/BrandIndexHistory/BrandReachSentimentMeta";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
  createActionMetric,
  fetchActionMetrics,
} from "../../../redux/actions/metricActions";
import { useDispatch } from "react-redux";
import MUIToolTip from "../../../Component/UI/ActionTooltip/MUIToolTip";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { createDomainUrlMapping } from "./ActionComponent/ActionModal";
import AnimatedNumber from "../../../Component/AnimatedNumber/AnimatedNumber";
import MUIIconButton from "../../../Component/UI/MUIIconButton/MUIIconButton";
import { InfoOutlined } from "@mui/icons-material";
import DetailedTableModal from "../common/MetricDetails";
import {
  formatName,
  sourceSplitToDomain,
} from "./CoreAttributes/CoreAttributes";
import { useLocation } from "react-router";
import AttributeBars from "./CompAttributes/CompAttributes";
import CustomDateFilter from "../common/CustomDateFilter";

const useQueryParams = () => {
  return new URLSearchParams(useLocation().search);
};

export const getTruncatedText = (summary) => {
  const words = summary?.split(" ");
  return customizeFontSizeAndStyle(
    words?.slice(0, 30).join(" ") + (words?.length > 50 ? "...." : ""),
    "18",
    "20"
  );
};

const CompComparisonComponent = ({
  compCoreAttributes,
  pastCompCoreAttributes,
  compCategoryDimensions,
  pastCompCategoryDimensions,
  compBrandIndexScore,
  pastCompBrandIndexScore,
  compPositiveAttributes,
  compNegativeAttributes,
  brandDomains,
  brandProduct,
  brandProductCategory,
  indexScoreMetaData,
  compIndexScoreMetaData,
  type,
  productTaxonomyData,
  selectedInput,
  customerId,
  categoryDimensionRatingSource,
  coreAttSourceData,
  reachSourceData,
  sentimentSourceData,
  positiveAttSource,
  negativeAttSource,
  sourceURLIds,
  secondaryCategoryMetaData,
  fetchRealTimeActionsSources,
  activeTarget,
  updateCustomFilterState,
  frequency,
  customDatesToDisplay,
  indexScoreDataForLineChart,
  startDate,
  endDate,
}) => {
  const dispatch = useDispatch();
  const query = useQueryParams();
  const reporting = query.get("reporting");

  const sourceMapping = {
    [`${ENTITY_LABELS.Brand} Pillars`]:coreAttSourceData,
    [ENTITY_LABELS.PurchaseCriteria]: categoryDimensionRatingSource,
  };
  const combineBrandAndCompMeta = () => {
    let compIndexMetaData = compIndexScoreMetaData || [];
    let dataToPush = {
      name: brandProduct,
      extras: indexScoreMetaData?.extras || indexScoreMetaData,
    };
    compIndexMetaData.push(dataToPush);
    return compIndexMetaData;
  };

  const filteredPurchaseDmesnions = getFilteredPurchaseDimensions(
    compCategoryDimensions
  );

  const dimensionMetricData =
    type === "Product" ? productTaxonomyData : compCoreAttributes;
  const tableData = prepareTableData(
    dimensionMetricData,
    compBrandIndexScore,
    filteredPurchaseDmesnions,
    pastCompCoreAttributes,
    pastCompBrandIndexScore,
    pastCompCategoryDimensions,
    { secondaryCategoryMetaData, brandProductCategory },
    type === "Product"
  );

  const targetHeaders = tableData?.headers;

  // comp filter

  const options = tableData?.headers; // Array of strings
  const [selectedOptions, setSelectedOptions] = useState([]);

  const [isFilterActive, setIsFilterActive] = useState(false);
  const [selectedCompIndex, setSelectedCompIndex] = useState([]);
  const [summary, setSummary] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [showBrandIndexBreakups, setShowBrandIndexBreakups] = useState(false);
  const [metaData, setMetaData] = useState();
  const [expandedRows, setExpandedRows] = useState({}); // Store expanded state for rows
  const [showModal, setShowModal] = useState(false);
  const [selectedMetric, setSelectedMetric] = useState("");
  const [keyPressed, setKeyPressed] = useState(false);
  const toggleRow = (attribute) => {
    setExpandedRows((prev) => ({
      ...prev,
      [attribute]: !prev[attribute],
    }));
  };

  useEffect(() => {
    if (selectedOptions.length) {
      const indexes = selectedOptions.map(
        (input) => targetHeaders?.indexOf(input)
        // tableData?.headers.indexOf(input)
      );
      setSelectedCompIndex(indexes);
      setIsFilterActive(true);
    } else {
      setSelectedCompIndex([]);
      setIsFilterActive(false);
    }
  }, [selectedOptions]);

  const handleChange = (selected) => {
    setSelectedOptions(selected ? selected.map((item) => item.label) : []);
  };

  // comp brand pagination
  const [startIndex, setStartIndex] = useState(0);
  const pageSize = 5; //
  const visibleHeaders = isFilterActive
    ? targetHeaders.filter((item) => selectedOptions.includes(item))
    : targetHeaders.slice(startIndex, startIndex + pageSize);

  const canGoBack = startIndex > 0;
  const canGoForward = startIndex + pageSize < tableData?.headers.length;

  const handleNext = () => {
    if (canGoForward) {
      setStartIndex(startIndex + pageSize);
    }
  };

  const handleClickI = (e) => {
    e.shiftKey && setKeyPressed("shiftKey");
    e.altKey && setKeyPressed("altKey");
    setShowModal(true);
  };

  const handlePrevious = () => {
    if (canGoBack) {
      setStartIndex(startIndex - pageSize);
    }
  };

  const getFilteredValues = (values = []) => {
    if (!isFilterActive) {
      return values.slice(startIndex, startIndex + pageSize);
    } else {
      return selectedCompIndex
        .filter((index) => index !== -1) // Filter out invalid indexes (-1)
        .map((index) => values[index]);
    }
  };

  const filteredData = (data, keysToKeep) => {
    return data
      ?.map((obj) => {
        const newObj = { name: obj.name };

        keysToKeep.forEach((key) => {
          if (obj.hasOwnProperty(key)) {
            newObj[key] = obj[key];
          }
        });

        return Object.keys(newObj).length > 1 ? newObj : null;
      })
      .filter((obj) => obj !== null);
  };

  let positiveAttBarChartData = transformDataForMultibarChart(
    compPositiveAttributes, true
  );
  let negativeAttBarChartData = transformDataForMultibarChart(
    compNegativeAttributes, true
  );

  positiveAttBarChartData = filteredData(
    positiveAttBarChartData,
    visibleHeaders
  );
  negativeAttBarChartData = filteredData(
    negativeAttBarChartData,
    visibleHeaders
  );

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  // Get LLM info using helper function - use same logic as payload
  // Use customDatesToDisplay (applied dates) instead of state dates
  const appliedStartDate = customDatesToDisplay?.startDate || startDate;
  const appliedEndDate = customDatesToDisplay?.endDate || endDate;
  const effectiveEndDate = activeTarget === "Recent" ? appliedEndDate : appliedStartDate;
  const llmInfo = getLLMInfo(indexScoreDataForLineChart, isChecked, appliedStartDate, effectiveEndDate);

  const fetchSummary = async () => {
    setIsLoading(true);
    try {
      const produtSpecificMetric =
        type === "Product" ? productTaxonomyData : compCoreAttributes;
      const jsonData = generateCompDashboardJsonPrompt(
        brandProduct,
        "Competitor",
        JSON.stringify(compBrandIndexScore),
        JSON.stringify(positiveAttBarChartData),
        JSON.stringify(negativeAttBarChartData),
        produtSpecificMetric,
        filteredPurchaseDmesnions,
        type === "Product"
      );
      const payload = {
        entity: brandProduct,
        dashboardType: "compDashboard",
        jsonData,
        isProduct: type === "Product",
      };
      const response = await getDashboardSummary(payload);
      setSummary(response);
    } catch (error) {
      console.error("Error fetching summary:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const chartDataArray = [positiveAttBarChartData, negativeAttBarChartData];

  const handleIndexScoreMetaModal = (
    isMeta,
    brandProductName,
    metric,
    score,
    rowJSON
  ) => {
    console.log("isMeta: " + isMeta);
    console.log("brandProductName: " + brandProductName);
    console.log("metric: " + metric);
    console.log("score: " + score);
    console.log("RowJSON: " + JSON.stringify(rowJSON));
    const reachOrSentiment = metric !== "Brand Index Score";
    const isReach = metric === "Rank";
    if (isMeta && reachOrSentiment) {
      let filterMeta = rowJSON?.category_name
        ? [rowJSON]
        : combineBrandAndCompMeta()?.filter(
          (obj) => obj?.name === brandProductName
        );

      if (filterMeta && filterMeta.length && filterMeta?.[0]?.extras) {
        setShowBrandIndexBreakups(true);
        setMetaData({
          data: filterMeta?.[0]?.extras,
          categoryName: filterMeta[0]?.category_name,
          isReach: isReach,
          brandProductName,
          score,
        });
      }
    }
  };

  const saveActions = async (
    title,
    rationale,
    sources,
    entities,
    realSource
  ) => {
    realSource = sourceSplitToDomain(realSource);
    const actionSources = Object.entries(Object.values(sources || {})?.[0] || {})?.map(
      ([domain_url, { aliases = [] }]) => ({
        domain_url,
        fullUrl: Array.from(new Set(aliases.map((item) => item?.source_alias_url)))?.filter(Boolean),
      })
    );
    const finalSource =
      realSource && realSource.length > 0
        ? realSource
        : actionSources

    try {
      // Prepare the modified object
      const modifiedObj = {
        title,
        rationale,
        brand: selectedInput?.brand || selectedInput?.product,
        persona: selectedInput?.persona,
        geography: selectedInput?.geography,
        market: selectedInput?.market,
        llm: selectedInput?.llm,
        category: selectedInput?.category,
        isProduct: !!selectedInput?.product,
        sources: finalSource,
      };

      // Create the payload
      const payload = {
        action_json: [modifiedObj],
        is_archived: 0,
        is_active: 1,
      };

      // Dispatch the createActionMetric and fetchActionMetrics
      dispatch(createActionMetric(customerId, payload))
        .then(() => {
          dispatch(fetchActionMetrics(customerId))
            .then(() => {
              toast.success("Action Added!", { autoClose: 700 });
            })
            .catch(() => {
              toast.error("Failed to fetch updated metrics!", {
                autoClose: 700,
              });
            });
        })
        .catch(() => {
          toast.error("Something went wrong while creating the action!", {
            autoClose: 700,
          });
        })
        .finally(() => {
          setIsActionLoading(false);
        });
    } catch (error) {
      setIsActionLoading(false);
      toast.error("Failed to fetch source URLs or process the action!", {
        autoClose: 700,
      });
    }
  };

  const getTooltipProps = (
    index,
    metric,
    sources,
    score,
    explanation,
    attribute
  ) => {
    return {
      sourceURLIds,
      metric: metric,
      attribute: attribute,
      metricScore: Number(score).toFixed(0),
      selectedInput,
      sources,
      key: index,
      addToActionHandler: saveActions,
      actionText: "Add To Action",
      isActionLoading: isActionLoading,
      realtimeSources: fetchRealTimeActionsSources,
      title: explanation,
      arrow: true,
      slotProps: {
        popper: {
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, -18],
              },
            },
          ],
        },
      },
    };
  };

  const hasAnyVisibleValues = (rows = []) =>
    rows.some((r) => getFilteredValues(r.values || []).length > 0);

  const getValueCell = (
    table,
    val,
    isColorApply,
    valIdx,
    row,
    color,
    sources,
    metric,
    explanation,
    attribute
  ) => {
    if (
      brandProduct === visibleHeaders?.[valIdx] &&
      table?.title !== "RBI: Primary Category" &&
      val?.value != null &&
      !isNaN(Number(val.value)) &&
      (row.attribute === "Rank" || val.value !== 0) && selectedInput?.llm?.toLowerCase().includes("search")
    ) {
      return (
        <MUIToolTip
          {...getTooltipProps(
            undefined,
            metric,
            sources,
            val.value,
            explanation,
            attribute
          )}
        >
          <div className="d-flex align-items-center justify-content-center flex-row">
            <span
              style={{
                cursor: "pointer",
                color: !isColorApply && !val?.isNa ? color : "grey",
              }}
              className={`h5 mb-0 me-1
} ${classes["main-value"]}`}
            >
              {val?.value != null &&
                !isNaN(Number(val.value)) &&
                (row.attribute == "Rank" || val.value != 0)
                ? Number(val.value).toFixed(0)
                : "NA"}
            </span>
            {val?.change != undefined && !val?.isNa && isChecked && (
              <>
                <FontAwesomeIcon
                  className={
                    val?.change < 0
                      ? `${classes["down-icon"]} text-danger me-1`
                      : `${classes["up-icon"]} text-success me-1`
                  }
                  icon={val?.change < 0 ? faSortDown : faSortUp}
                />
                <span className={classes.delta}>
                  {val?.change > 0
                    ? `${Number(val?.change).toFixed(0)}`
                    : Number(Math.abs(val?.change)).toFixed(0)}
                </span>
              </>
            )}
          </div>
        </MUIToolTip>
      );
    }
    return (
      <CustomTooltip explaination={val?.explanation}>
        <div
          // title={val?.explaination}
          className="d-flex align-items-center justify-content-center flex-row"
        >
          <span
            onClick={() => {
              handleIndexScoreMetaModal(
                isColorApply,
                visibleHeaders?.[valIdx],
                row.attribute,
                Number(val.value).toFixed(0)
              );
            }}
            onMouseEnter={(e) => {
              if (row.attribute !== "Brand Index Score") {
                e.target.style.color = "#2196F3";
              }
            }} // Change color on hover
            onMouseLeave={(e) =>
            (e.target.style.color =
              !isColorApply && !val?.isNa ? color : "grey")
            }
            style={{
              cursor: "pointer",
              color: !isColorApply && !val?.isNa ? color : "grey",
            }}
            className={`h5 mb-0 me-1
} ${classes["main-value"]}`}
          >
            {val?.value != null &&
              !isNaN(Number(val.value)) &&
              (row.attribute === "Rank" || val.value !== 0)
              ? Number(val.value).toFixed(0)
              : "NA"}
          </span>
          {val?.change !== undefined && !val?.isNa && isChecked && (
            <>
              <FontAwesomeIcon
                className={
                  val?.change < 0
                    ? `${classes["down-icon"]} text-danger me-1`
                    : `${classes["up-icon"]} text-success me-1`
                }
                icon={val?.change < 0 ? faSortDown : faSortUp}
              />
              <span className={classes.delta}>
                {val?.change > 0
                  ? `${Number(val?.change).toFixed(0)}`
                  : Number(Math.abs(val?.change)).toFixed(0)}
              </span>
            </>
          )}
        </div>
      </CustomTooltip>
    );
  };

  let coreAttributesData =
    (compCoreAttributes &&
      coreAttributesDataTransform(compCoreAttributes, brandProduct)) ||
    [];

  let purchaseDimData =
    compCategoryDimensions &&
    coreAttributesDataTransform(compCategoryDimensions, brandProduct);

  const metricDatalookUp = {
    [`${ENTITY_LABELS.Brand} Pillars`]:coreAttributesData,
    [ENTITY_LABELS.PurchaseCriteria]: purchaseDimData,
  };

  function renderHeaders() {
    const headers = [titleMapping?.[selectedMetric], ...visibleHeaders];

    return (
      <TableHead className={classes.table_head}>
        <TableRow>
          {headers.map((header, index) => {
            let domain = extractDomain(brandDomains?.[header]);

            return (
              <TableCell key={index} className={classes.table_head_cell}>
                <div className={classes.table_head_content}>
                  {index != 0 && (
                    <img
                      data-html2canvas-ignore
                      className={classes.table_head_logo}
                      src={`https://img.logo.dev/${domain}?token=pk_SaDf4t2eRsW5Fc84zgJRZA`}
                    />
                  )}
                  <div
                    className={
                      index === 0
                        ? classes.table_head_text_comp
                        : classes.table_head_text
                    }
                  >
                    <div className={classes.table_head_title}>
                      <span>
                        <Tooltip title={metricExplainations[header]}>
                          {header}
                        </Tooltip>
                      </span>
                    </div>
                  </div>
                </div>
              </TableCell>
            );
          })}
        </TableRow>
      </TableHead>
    );
  }

  return (
    <>

      {frequency === 'Custom' && <CustomDateFilter
        activeTarget={activeTarget}
        handleChange={updateCustomFilterState}
        customDatesToDisplay={customDatesToDisplay}
      />}
      <DetailedTableModal
        show={showModal}
        headers={visibleHeaders}
        onClose={() => {
          setShowModal(false);
          setKeyPressed(false);
        }}
        renderHeaders={renderHeaders}
        data={metricDatalookUp?.[selectedMetric] || []}
        formatName={formatName}
        classes={classes}
        pdfHeight={400}
        pdfTitle={`${selectedInput?.brand || selectedInput?.product
          }-${titleMapping?.[selectedMetric]}`}
        showSplitTables={keyPressed}
      />
      <Modal
        open={showBrandIndexBreakups}
        handleClose={() => setShowBrandIndexBreakups(false)}
        width={1200}
      >
        <BrandReachSentimentMeta
          isReach={metaData?.isReach}
          data={metaData?.data}
          addToActionHandler={saveActions}
          sources={{ reachSourceData, sentimentSourceData }}
          isComp={true}
          isMainBrand={metaData?.brandProductName === brandProduct}
          selectedBrandProduct={metaData?.brandProductName}
          score={metaData?.score}
          categoryName={metaData?.categoryName}
          selectedInput={{ ...selectedInput, brand: metaData?.brandProductName, product: metaData?.brandProductName }}
        />
      </Modal>
      <div className="col-md-12 mt-4">
        <div className="col-md-12">
          <div className="graphGreyBg">
            <p style={{ display: "flex", justifyContent: "center" }}>
              <h4>Headlines</h4>
              &nbsp; &nbsp;
              <MUIButton
                onClick={fetchSummary}
                variant="outlined"
                className={classes.regenerate}
                startIcon={<AutoAwesomeOutlinedIcon />}
              >
                Generate
              </MUIButton>
            </p>
            <div className="graphsummary font-11">
              {isLoading ? (
                <div
                  style={{
                    fontSize: "19px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "20px",
                    // color: "green",
                  }}
                >
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  &nbsp; Loading...
                </div>
              ) : summary && typeof summary === "string" ? (
                <>
                  <Markdown className="markTable">
                    {isExpanded
                      ? customizeFontSizeAndStyle(summary, "18", "20")
                      : getTruncatedText(summary)}
                  </Markdown>
                  <span
                    style={{ cursor: "pointer", color: "blue" }}
                    onClick={() => setIsExpanded(!isExpanded)}
                  >
                    {isExpanded ? "Show Less" : "Show More"}
                  </span>
                </>
              ) : (
                // news
                ""
              )}
            </div>
          </div>
        </div>

        <p> </p>

        <div style={{
          fontSize: "15px",
          marginLeft: '10px',
          marginRight: '10px',
          marginBottom: '10px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '15px',
          position: 'relative'
        }}>
          <label>
            <input
              style={{}}
              type="checkbox"
              checked={isChecked}
              onChange={handleCheckboxChange}
            />
            &nbsp;
            {"Show Change Data"}
          </label>

          {llmInfo && (
            <div style={{
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
              padding: '6px 16px',
              backgroundColor: '#e3f2fd',
              border: '1px solid #90caf9',
              borderRadius: '6px',
              fontSize: '14px',
              fontWeight: '600',
              color: '#1565c0',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}>
              <span style={{ color: '#0d47a1', marginRight: '8px' }}>LLM:</span>
              {llmInfo}
            </div>
          )}

          <div style={{ width: '120px' }}></div>
        </div>

        <div
          className="d-flex justify-content-evenly"
          style={{
            margin: "-20px 0px 10px 63%",
            width: "40%",
            // marginLeft: "96%",
            cursor: "pointer",
          }}
        >
          <CustomSelectWithApply
            selectedOptions={selectedOptions}
            options={options}
            handleChange={handleChange}
          />

          {!isFilterActive && canGoBack && (
            <i
              style={{ fontSize: "22px", marginTop: "5px" }}
              onClick={handlePrevious}
              className="bi bi-arrow-left-circle-fill"
            ></i>
          )}
          {!isFilterActive && canGoForward && (
            <i
              style={{ fontSize: "22px", marginTop: "5px" }}
              onClick={handleNext}
              className="bi bi-arrow-right-circle-fill"
            ></i>
          )}
        </div>

        {tableData.tables.map((table, tableIndex) => (
          <React.Fragment key={tableIndex}>
            <div className="card custCard mb-4" id={table.id}>
              <table className="table table-striped mb-0">
                <thead>
                  <tr className="tblHeader text-center">
                    <th
                      scope="col"
                      style={{
                        // width: "150px",
                        textAlign: "left",
                        paddingLeft: "15px",
                        verticalAlign: "middle",
                      }}
                    >
                      <div className={classes.table_head_title}>
                        <span>
                          <Tooltip title={metricExplainations[table.title]}>
                            <span
                              style={{
                                color: "black",
                                fontSize: "1rem",
                                fontWeight: "500",
                              }}
                            >
                              {titleMapping?.[table.title]}
                            </span>
                          </Tooltip>
                        </span>
                        {(table.title === `${ENTITY_LABELS.Brand} Pillars` ||
                          table.title === ENTITY_LABELS.PurchaseCriteria) && (
                            <MUIIconButton
                              onClick={(e) => {
                                handleClickI(e);
                                setSelectedMetric(table.title);
                              }}
                            >
                              <InfoOutlined />
                            </MUIIconButton>
                          )}
                      </div>
                    </th>

                    {visibleHeaders.map((header, idx) => (
                      <th
                        scope="col"
                        key={idx}
                        style={{
                          width: "150px",
                          verticalAlign: "top", // Ensures the header remains at the top
                        }}
                      >
                        {(tableIndex === 0 || reporting) && (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center", // Centers the content horizontally
                              justifyContent: "flex-start", // Aligns the logo at the top
                              height: "100%", // Ensures full height usage
                            }}
                          >
                            <img
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "6px",
                                marginBottom: "5px", // Adds spacing between logo and text
                                objectFit: "contain",
                              }}
                              src={`https://img.logo.dev/${extractDomain(
                                brandDomains?.[header]
                              )}?token=pk_SaDf4t2eRsW5Fc84zgJRZA`}
                              alt={""}
                            />
                            <span
                              style={{
                                wordWrap: "break-word", // Ensures long text wraps
                                textAlign: "center",
                                marginTop: "5px", // Adds space between logo and text
                              }}
                            >
                              {header}
                            </span>
                          </div>
                        )}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {/* {table?.rows && table?.rows.length ? ( */}
                  {(table?.rows && table?.rows.length && (table.title !== "RBI" || hasAnyVisibleValues(table?.rows))) ? (
                    table.rows.map((row, idx) => {
                      const isProductDimensions =
                        table.title === "Product Dimensions";
                      const isParentRow = !row.values?.[0]?.parentCategory;
                      const isExpanded = expandedRows[row.attribute];

                      if (isProductDimensions) {
                        if (isParentRow) {
                          // Parent Row for Product dimensions
                          return (
                            <React.Fragment key={idx}>
                              <tr>
                                <td
                                  valign="middle"
                                  style={{
                                    width: "150px",
                                    textAlign: "left",
                                    paddingLeft: "10px",
                                    // fontWeight: "bold",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => toggleRow(row.attribute)}
                                >
                                  {isExpanded ? (
                                    <KeyboardArrowUpIcon />
                                  ) : (
                                    <KeyboardArrowDownIcon />
                                  )}{" "}
                                  &nbsp;
                                  {titleMapping?.[row.attribute] ||
                                    row.attribute}
                                </td>
                                {getFilteredValues(row.values)
                                  // .slice(startIndex, startIndex + pageSize)
                                  .map((val, valIdx) => {
                                    const isColorApply =
                                      table?.title === "RBI" ||
                                      table?.title === "Rank" ||
                                      table?.title === "Favorability";
                                    let color = "#dc3545";
                                    if (Number(val?.value).toFixed(0) >= 7)
                                      color = "#2196F3";
                                    if (Number(val?.value).toFixed(0) >= 9)
                                      color = "#198754";
                                    return (
                                      <td
                                        key={valIdx}
                                        style={{
                                          width: "150px",
                                          textAlign: "center",
                                          // cursor: "pointer",
                                        }}
                                      >
                                        {getValueCell(
                                          table,
                                          val,
                                          isColorApply,
                                          valIdx,
                                          row,
                                          color,
                                          sourceMapping?.[table?.title],
                                          table?.title,
                                          val?.explanation,
                                          row.attribute
                                        )}
                                      </td>
                                    );
                                  })}
                              </tr>

                              {/* Subcategories */}
                              {isExpanded &&
                                table.rows
                                  .filter(
                                    (subRow) =>
                                      subRow.values?.[0]?.parentCategory ===
                                      row.attribute
                                  )
                                  .map((subRow, subIdx) => (
                                    <tr key={`sub-${subIdx}`}>
                                      <td
                                        valign="middle"
                                        style={{
                                          width: "150px",
                                          textAlign: "left",
                                          paddingLeft: "42px",
                                        }}
                                      >
                                        {titleMapping?.[subRow.attribute] ||
                                          subRow.attribute}
                                      </td>
                                      {getFilteredValues(subRow.values)
                                        // .slice(startIndex, startIndex + pageSize)
                                        .map((val, valIdx) => {
                                          const isColorApply =
                                            table?.title === "RBI" ||
                                            table?.title === "Rank" ||
                                            table?.title === "Favorability";
                                          let color = "#dc3545";
                                          if (
                                            Number(val?.value).toFixed(0) >= 7
                                          )
                                            color = "#2196F3";
                                          if (
                                            Number(val?.value).toFixed(0) >= 9
                                          )
                                            color = "#198754";
                                          return (
                                            <td
                                              key={valIdx}
                                              style={{
                                                width: "150px",
                                                textAlign: "center",
                                                cursor: "pointer",
                                              }}
                                            >
                                              <CustomTooltip
                                                explaination={val?.explanation}
                                              >
                                                <div
                                                  // title={val?.explaination}
                                                  className="d-flex align-items-center justify-content-center flex-row"
                                                >
                                                  <span
                                                    onClick={() => {
                                                      handleIndexScoreMetaModal(
                                                        isColorApply,
                                                        visibleHeaders?.[
                                                        valIdx
                                                        ],
                                                        row.attribute
                                                      );
                                                    }}
                                                    onMouseEnter={(e) => {
                                                      if (
                                                        row.attribute !=
                                                        "Brand Index Score"
                                                      ) {
                                                        e.target.style.color =
                                                          "#2196F3";
                                                      }
                                                    }} // Change color on hover
                                                    onMouseLeave={(e) =>
                                                    (e.target.style.color =
                                                      !isColorApply &&
                                                        !val?.isNa
                                                        ? color
                                                        : "grey")
                                                    }
                                                    style={{
                                                      cursor: "pointer",
                                                      color:
                                                        !isColorApply &&
                                                          !val?.isNa
                                                          ? color
                                                          : "grey",
                                                    }}
                                                    className={`h5 mb-0 me-1
                              } ${classes["main-value"]}`}
                                                  >
                                                    {val?.value != null &&
                                                      !isNaN(Number(val.value)) &&
                                                      (row.attribute == "Rank" ||
                                                        val.value != 0)
                                                      ? Number(
                                                        val.value
                                                      ).toFixed(0)
                                                      : "NA"}
                                                  </span>
                                                  {val?.change != undefined &&
                                                    !val?.isNa &&
                                                    isChecked && (
                                                      <>
                                                        <FontAwesomeIcon
                                                          className={
                                                            val?.change < 0
                                                              ? `${classes["down-icon"]} text-danger me-1`
                                                              : `${classes["up-icon"]} text-success me-1`
                                                          }
                                                          icon={
                                                            val?.change < 0
                                                              ? faSortDown
                                                              : faSortUp
                                                          }
                                                        />
                                                        <span
                                                          className={
                                                            classes.delta
                                                          }
                                                        >
                                                          {val?.change > 0
                                                            ? `${Number(
                                                              val?.change
                                                            ).toFixed(0)}`
                                                            : Number(
                                                              Math.abs(
                                                                val?.change
                                                              )
                                                            ).toFixed(0)}
                                                        </span>
                                                      </>
                                                    )}
                                                </div>
                                              </CustomTooltip>
                                            </td>
                                          );
                                        })}
                                    </tr>
                                  ))}
                            </React.Fragment>
                          );
                        }

                        return null; // Skip subcategory rows initially for Product dimensions
                      }

                      if (["RBI"].includes(table.title)) {
                        return (
                          <tr>
                            <td
                              valign="middle"
                              className="border-end"
                              style={{
                                width: "150px",
                                textAlign: "left",
                                paddingLeft: "15px",
                                fontWeight: 500,
                                fontSize: "0.8rem",
                                textTransform: "capitalize",
                              }}
                            >
                              {row.attribute}
                            </td>
                            {getFilteredValues(row.values).map(
                              (eachRow, idx) => (
                                <td
                                  key={idx}
                                  valign="middle"
                                  style={{
                                    width: "150px",
                                    textAlign: "center",
                                    paddingLeft: "10px",
                                  }}
                                >
                                  <div className={classes.content}>
                                    <AnimatedNumber
                                      className={classes.score}
                                      start={10}
                                      end={eachRow?.rankings.total || 0}
                                      duration={1000}
                                      title="Brand Index Score"
                                    >
                                      {isChecked &&
                                        !isNaN(eachRow.rankings.totalDiff) && (
                                          <span
                                            style={{
                                              position: "absolute",
                                              right: "40px",
                                              top: "10px",
                                              fontSize: "10px",
                                              fontWeight: 500,
                                              color:
                                                eachRow.rankings.totalDiff > 0
                                                  ? "#198754"
                                                  : "#dc3545",
                                            }}
                                          >
                                            {Math.abs(
                                              eachRow.rankings.totalDiff
                                            )}
                                          </span>
                                        )}
                                    </AnimatedNumber>
                                    <div className={classes.sub_content}>
                                      <span
                                        title="Reach"
                                        className={classes.subScoreRank}
                                        onClick={() => {
                                          handleIndexScoreMetaModal(
                                            true,
                                            visibleHeaders?.[idx],
                                            "Rank",
                                            Number(
                                              eachRow?.rankings.rank
                                            ).toFixed(0),
                                            eachRow
                                          );
                                        }}
                                      >
                                        {isChecked &&
                                          !isNaN(
                                            eachRow.rankings.rankingDiff
                                          ) && (
                                            <span
                                              style={{
                                                position: "absolute",
                                                left: "25px",
                                                top: "0px",
                                                fontSize: "10px",
                                                fontWeight: 500,
                                                color:
                                                  eachRow.rankings.rankingDiff >
                                                    0
                                                    ? "#198754"
                                                    : "#dc3545",
                                              }}
                                            >
                                              {Math.abs(
                                                eachRow.rankings.rankingDiff
                                              )}
                                            </span>
                                          )}
                                        {eachRow?.rankings.rank}
                                      </span>
                                      <hr className={classes.divider} />
                                      <span
                                        title="Sentiment"
                                        className={classes.subScoreFav}
                                        onClick={() => {
                                          handleIndexScoreMetaModal(
                                            true,
                                            visibleHeaders?.[idx],
                                            "Favourability",
                                            Number(
                                              eachRow?.rankings.favorability
                                            ).toFixed(0),
                                            eachRow
                                          );
                                        }}
                                      >
                                        {isChecked &&
                                          !isNaN(
                                            eachRow.rankings.favorabilityDiff
                                          ) && (
                                            <span
                                              style={{
                                                position: "absolute",
                                                left: "25px",
                                                top: "0px",
                                                fontSize: "10px",
                                                fontWeight: 500,
                                                color:
                                                  eachRow.rankings
                                                    .favorabilityDiff > 0
                                                    ? "#198754"
                                                    : "#dc3545",
                                              }}
                                            >
                                              {Math.abs(
                                                eachRow.rankings
                                                  .favorabilityDiff
                                              )}
                                            </span>
                                          )}
                                        {eachRow?.rankings.favorability}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                              )
                            )}
                          </tr>
                        );
                      }

                      // Default behavior for other rows
                      return (
                        <tr key={idx}>
                          <td
                            valign="middle"
                            style={{
                              width: "150px",
                              textAlign: "left",
                              paddingLeft: row?.values?.[0]?.parentCategory
                                ? "25px"
                                : "15px",
                            }}
                          >
                            <Tooltip
                              title={
                                metricExplainations[
                                titleMapping?.[row.attribute] || row.attribute
                                ]
                              }
                            >
                              {titleMapping?.[row.attribute] || row.attribute}
                            </Tooltip>
                          </td>

                          {getFilteredValues(row.values)
                            // .slice(startIndex, startIndex + pageSize)
                            .map((val, valIdx) => {
                              const isColorApply =
                                table?.title === "RBI" ||
                                table?.title === "Rank" ||
                                table?.title === "Favorability";
                              let color = "#dc3545";
                              if (Number(val?.value).toFixed(0) >= 7)
                                color = "#2196F3";
                              if (Number(val?.value).toFixed(0) >= 9)
                                color = "#198754";
                              return (
                                <td
                                  key={valIdx}
                                  style={{
                                    width: "150px",
                                    textAlign: "center",
                                    // cursor: "pointer",
                                  }}
                                >
                                  {getValueCell(
                                    table,
                                    val,
                                    isColorApply,
                                    valIdx,
                                    row,
                                    color,
                                    sourceMapping?.[table?.title],
                                    table?.title,
                                    val?.explanation,
                                    row.attribute
                                  )}
                                </td>
                              );
                            })}
                        </tr>
                      );
                    })
                  ) : (
                    <EmptyView message="Data Not Available" />
                  )}
                </tbody>
              </table>
            </div>
          </React.Fragment>
        ))}
      </div>

      <AttributeBars
        negativeAttributes={negativeAttBarChartData}
        positiveAttributes={positiveAttBarChartData}
        selectedInput={selectedInput}
        sources={negativeAttSource}
        saveActions={saveActions}
        isActionLoading={isActionLoading}
        isCompetitor={true}
      />
      {/* 
      {chartDataArray?.map((data, index) => {
        return (
          <div className="col-md-12 mt-4">
            <div className="card p-3 custCard">
              <div className="mb-3 d-flex justify-content-between align-items-center"></div>
              <div>
                <ReMultibarChart
                  mainIndex={index}
                  data={data}
                  isCompetitor={true}
                  selectedInput={selectedInput}
                  sources={negativeAttSource}
                  saveActions={saveActions}
                  isActionLoading={isActionLoading}
                />
              </div>
            </div>
          </div>
        );
      })} */}

      <ToastContainer />
    </>
  );
};

export default CompComparisonComponent;
